import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalRepViewProspectsDocument = gql`
  query SalesPortalRepViewProspects(
    $businessOrganizationUUID: uuid!
    $userTimezone: String
  ) {
    getSalesPortalProspectListInfo(
      business_organization_id: $businessOrganizationUUID
      user_timezone: $userTimezone
    ) {
      currency_code
      date_added_at
      date_added_display
      last_activity_at
      last_activity_display
      restaurant_address
      restaurant_id
      restaurant_name
      supplier_id
      weekly_estimated_value_in_micros
    }
  }
`;
export function useSalesPortalRepViewProspectsQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >(SalesPortalRepViewProspectsDocument, options);
}
export function useSalesPortalRepViewProspectsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >(SalesPortalRepViewProspectsDocument, options);
}
export type SalesPortalRepViewProspectsQueryHookResult = ReturnType<
  typeof useSalesPortalRepViewProspectsQuery
>;
export type SalesPortalRepViewProspectsLazyQueryHookResult = ReturnType<
  typeof useSalesPortalRepViewProspectsLazyQuery
>;
export type SalesPortalRepViewProspectsQueryResult = Apollo.QueryResult<
  Types.SalesPortalRepViewProspectsQuery,
  Types.SalesPortalRepViewProspectsQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalRepViewProspectsQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalRepViewProspectsQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >(SalesPortalRepViewProspectsDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalRepViewProspectsLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalRepViewProspectsLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalRepViewProspectsQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalRepViewProspectsQuery,
    Types.SalesPortalRepViewProspectsQueryVariables
  >(SalesPortalRepViewProspectsDocument, lazyOptions);
}
